import React from 'react';
import glamorous from 'glamorous';


export const ConstructionContainer = glamorous.div({
  alignItems: 'center',
  backgroundColor: '#f2f2f2',
  display: 'flex',
  flex: 'auto',
  flexDirection: 'row',
  height: '100vh',
  justifyContent: 'center',
  marginRight: 20
})

export default function UnderConstructionView(props) {
  return (
    <ConstructionContainer>
      <h1>Under Development</h1>
    </ConstructionContainer>
  );
}



// WEBPACK FOOTER //
// ./src/modules/appnav/UnderConstructionView.js